import React from 'react';

import { Icon } from '@chakra-ui/react';
import { XIcon } from 'lucide-react';

import { IconButton } from '@/components/core';

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      icon={
        <Icon
          as={XIcon}
          boxSize={21}
          opacity={0.5}
          _groupHover={{
            opacity: 1,
          }}
        />
      }
      aria-label='Close'
      // variant='ghost'
      variant='ghost'
      size='sm'
      className='group'
      onClick={onClick}
    />
  );
};
